import { render } from "./AccountSwitcherLoader.vue?vue&type=template&id=a78af224&scoped=true"
import script from "./AccountSwitcherLoader.vue?vue&type=script&lang=js"
export * from "./AccountSwitcherLoader.vue?vue&type=script&lang=js"

import "./AccountSwitcherLoader.vue?vue&type=style&index=0&id=a78af224&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a78af224"]])

export default __exports__